import { ErrorBoundary } from 'react-error-boundary';

import { instanaReportError } from '@bizzabo/instana-api';

import ErrorPage from '../ErrorPage';
import useTypeTracking from '../../../analytics';

type Props = {
    onReset: () => void;
};

const ErrorBoundaryWrapper: React.FC<Props> = ({ onReset, children }) => {
    const { trackClickEvent } = useTypeTracking();

    const onError = (error: Error, info: { componentStack: string }) => {
        instanaReportError(error, { componentStack: info.componentStack });
    };

    const onResetHandle = () => {
        onReset();
        trackClickEvent({
            subCategory: 'ERROR_CLOSED',
        });
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorPage} onError={onError} onReset={onResetHandle}>
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryWrapper;
